import { addRoute } from "../shared/router";
import home from "./page.vue";

addRoute("/", home);
